import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '../elements-buttons/Button';
import { FormattedMessage } from 'react-intl';

const EmptyAddons = ({ toggleModal }) => (
  <div className="row text-center empty-addons-placeholder">
    <div className="col-sm-6 col-sm-offset-3">
      <img
        src="/web-hosting/assets/images/empty-addons.svg?v=rb"
        alt="empty addons placeholder"
        className="img-responsive"
      />
      <h4><FormattedMessage id="hosting.empty_addons.add_additional_services_heading" defaultMessage="Add additional services that guests can book with your space"/></h4>
      <Button
        onClick={() => toggleModal('createAddOnModal')}
        className="margin-lg-top"
        category="primary"
      >
        <span className="text-large">+</span>
        <span> <FormattedMessage id="hosting.empty_addons.add_additional_services_button_text_add_item" defaultMessage="Add Item"/></span>
      </Button>
    </div>
  </div>
);

EmptyAddons.propTypes = {
  toggleModal: PropTypes.func
};

export default EmptyAddons;
